import Home from './containers/Home';

const App = () => {
  return (
    <main className='App'>
      <div>
        <Home />
      </div>
    </main>
  );
};

export default App;
